import { render, staticRenderFns } from "./ideaColumnTemp.vue?vue&type=template&id=660dc99a&scoped=true"
import script from "./ideaColumnTemp.vue?vue&type=script&lang=js"
export * from "./ideaColumnTemp.vue?vue&type=script&lang=js"
import style0 from "./ideaColumnTemp.vue?vue&type=style&index=0&id=660dc99a&prod&lang=scss&scoped=true"
import style1 from "./ideaColumnTemp.vue?vue&type=style&index=1&id=660dc99a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660dc99a",
  null
  
)

export default component.exports